import { useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { replacePlaceholder } from '@/helpers/cms';
import { DEFAULT_CURRENCIES } from '@/helpers/currency';
import { groupMembeRakeback } from '@/helpers/user';
import { formatWalletValue } from '@/helpers/wallet';
import { usePlayerRakebacks } from '@/modules/promotions/hooks/usePlayerRakebacks';
import { useGetCommonStore } from '@/store';

const RAKEBACK_SUM = 'rakeback_sum';

export const useFormatRakebackAmount = (text: string | null) => {
  const useCommonStore = useGetCommonStore();

  const { user } = useCommonStore(
    useShallow((state) => ({
      user: state.user,
    }))
  );

  const { data: rakebacks } = usePlayerRakebacks();

  const userCurrencyRakeback = useMemo(() => {
    if (!(user && rakebacks)) return;
    const { currency } = user;

    return rakebacks.find((item) => item.currency === currency);
  }, [rakebacks, user]);

  const formattedRakebackAmount = useMemo(() => {
    if (!user) return '';

    const userWithRakeback = groupMembeRakeback(user);

    if (!userWithRakeback) return '';

    const { currency } = user;

    return String(
      formatWalletValue(
        currency,
        Number(userCurrencyRakeback?.amountCentsDecimal) || 0,
        DEFAULT_CURRENCIES,
        true
      )
    );
  }, [user, userCurrencyRakeback]);

  if (!text) return '';

  return replacePlaceholder(text, RAKEBACK_SUM, formattedRakebackAmount);
};
